import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="London">
                <h1>Flutter App Development Company in UK</h1>
              </div>
              <p className="main_para">
                We specialize in developing cost-effective apps for customers
                all around the world with innovative and cutting-edge Flutter
                app development services. Create platform-independent digital
                experiences with our Flutter app developers, who will assist you
                in developing natively compiled, vigorous web, mobile, and
                desktop applications.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
